var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/AnonFooter.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Grid } from '@wds/grid';
import { Box } from '@wds/box';
import classnames from 'classnames';
import { LanguageListLO } from './LanguageMenu';
import { AnonFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import CopyRight from './CopyRight';
import { SMFooterContext } from './SMFooterContext';
import useStyles from './useStyles';
var AnonFooter = function AnonFooter() {
  var _useContext = useContext(SMFooterContext),
    variant = _useContext.variant;
  var _useStyles = useStyles(),
    footerAnon = _useStyles.footerAnon,
    fullHeight = _useStyles.fullHeight,
    footerBorder = _useStyles.footerBorder;
  var TrusteFooterSeals = function TrusteFooterSeals() {
    return /*#__PURE__*/React.createElement(Grid.Item, {
      md: 5,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexJustify: "flex-end",
      flexAlign: "center",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(TrusteSeals, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 11
      }
    })));
  };
  var footerClassNames = classnames(footerAnon, 'sm-footer');
  return /*#__PURE__*/React.createElement("div", {
    className: footerClassNames,
    "data-testid": "AnonFooter",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, variant === 'default' ? [/*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 11
    },
    key: "0"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: footerBorder,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(AnonFooterLinks, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 11
    },
    key: "1"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: footerBorder,
    py: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(LanguageListLO, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    },
    key: "2"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    md: 7,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    className: fullHeight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(CopyRight, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 17
    }
  }))), TrusteFooterSeals())] : /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    md: 7,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: variant === 'default' ? 'row' : 'column',
    flexAlign: variant === 'default' ? 'center' : 'flex-start',
    flexJustify: variant === 'default' ? 'flex-start' : 'center',
    className: fullHeight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(AnonFooterLinks, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(CopyRight, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 17
    }
  }))), TrusteFooterSeals()));
};
export default AnonFooter;
//# sourceMappingURL=AnonFooter.js.map